<template>
  <v-app>
    <v-container
      fluid
      class="fill-height"
    >
      <v-row v-if="isLoading">
        <v-col class="text-center">
          <v-progress-circular
            color="primary"
            indeterminate
            size="70"
          />
          <p class="text-caption pt-3">
            Signing you in...
          </p>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col class="text-center">
          <v-dialog
            v-model="dialog"
            max-width="400"
            persistent
          >
            <v-card class="pa-4 text-center align-center">
              <v-icon
                color="error"
                size="60"
              >
                mdi-close-circle-outline
              </v-icon>
              <p
                class="mt-4"
                v-html="errorMessage"
              />
              <v-btn
                variant="flat"
                class="mt-4"
                color="primary"
                @click="goToLogin"
              >
                Go to login
              </v-btn>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>


<script>
export default {
  name: "OAuthExchange",
  data() {
    return {
      isLoading: true,
      dialog: false,
      errorMessage: "",
      oAuthCode: this.$route.query.oAuthCode
    };
  },
  mounted() {
    this.exchangeToken();
  },
  methods: {
    goToLogin() {
      this.$router.push("/login");
    },
    exchangeToken() {
      console.log("exchangeToken");
      if (!this.oAuthCode) {
        console.error("No OAuth token in URL!");
        this.$router.replace("/login");
        return;
      }

      const payload = {
        oAuthCode: this.oAuthCode,
        clientID: this.AUTH_CLIENT_ID
      };

      this.$http.post(`${this.ADMIN_API_URL}/silentLogin`, payload).then(
        function (data) {
          this.isLoading = false;
          var loggedInUser = data.body.data;
          this.$store.commit("setLoggedInUser", loggedInUser);
          localStorage.setItem("login_user", JSON.stringify(loggedInUser));
          localStorage.setItem("admin_user_token", loggedInUser.token);
          localStorage.setItem("JwtExhToken", loggedInUser.jwtExhToken);

          this.$router.push({ path: "/home" });
        },
        function (failure) {
         console.log("ERROR", failure);
          this.isLoading = false;
          this.dialog = true;
          this.errorMessage = "Something went wrong. Please try again.";
        }
      );
    }
  }
};
</script>
